import { render } from "./FirmInvConfirm.vue?vue&type=template&id=021f1f66&scoped=true"
import script from "./FirmInvConfirm.vue?vue&type=script&lang=js"
export * from "./FirmInvConfirm.vue?vue&type=script&lang=js"

import "./FirmInvConfirm.vue?vue&type=style&index=0&id=021f1f66&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021f1f66"]])

export default __exports__